const filterAssets = {
    agent_id: { label: 'Agent', icon: 'headset' },
    channel: { label: 'Channel', icon: 'channels' },
    contact_point: { label: 'Contact point', icon: 'id-card' },
    initial_direction: { label: 'Direction', icon: 'exchange' },
    queue_id: { label: 'Queue', icon: 'users' },
    tag_id: { label: 'Tags', icon: 'tag' },
    team_id: { label: 'Team', icon: 'team' },
    media_type: { label: 'Media type', icon: 'channels' },
    custom_fields: { label: 'Attributes', icon: 'input' },
};
/**
 * Safely get the assets associated with a filter field.
 *
 * In case the API returns a new dashboard filter that is not yet supported by
 * the frontend, we return the raw field as the label and a generic icon,
 * instead of throwing an error or not rendering the filter at all.
 */
export function getFilterAssets(field) {
    const assets = filterAssets[field];
    if (!assets) {
        return { label: field, icon: 'filter' };
    }
    return assets;
}
const operatorAssets = {
    is_one: {
        label: 'any of the selected values',
        orderIndex: 1,
        requiresValues: false,
    },
    is_not_one: {
        label: 'none of the selected values',
        orderIndex: 2,
        requiresValues: true,
    },
    is_all: {
        label: 'all of the selected values',
        orderIndex: 3,
        requiresValues: true,
    },
    is_not_all: {
        label: 'not all of the selected values',
        orderIndex: 4,
        requiresValues: true,
    },
    is_empty: {
        label: 'no value',
        orderIndex: 5,
        requiresValues: false,
    },
    is_not_empty: {
        label: 'any value',
        orderIndex: 6,
        requiresValues: false,
    },
};
/**
 * Safely get the assets associated with a filter operator.
 *
 * In case the API returns a new filter operator that is not yet supported by
 * the frontend, we return the raw operator as the label and sensible defaults,
 * instead of throwing an error or not rendering the operator at all.
 */
export function getOperatorAssets(operator) {
    const assets = operatorAssets[operator];
    if (!assets) {
        return { label: operator, orderIndex: 99, requiresValues: true };
    }
    return assets;
}
